<template>
    <v-container mb-12>
        <v-row>
            <v-col
                cols="12"
                md="6"
            >
                <!-- Homepage Image -->
                <div class="d-flex fill-height align-center justify-center">
                    <v-img
                        max-width="80%"
                        :src="require('../assets/handle.svg')"
                    />
                </div>
            </v-col>
            <v-col
                cols="12"
                md="6"
            >
                <!-- Create Account from Homepage -->
                <div class="display-3 text-center px-5 primary--text">
                    Come Connect
                </div>
                <div class="headline text-center grey--text font-weight-light px-5 mb-8">
                    Keep your links in one place
                </div>
                <create-account
                    :from-homepage="true"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import CreateAccount from './SignUp/CreateAccount.vue'
export default {
    components: {
        CreateAccount
    }
}
</script>

<style lang="scss" scoped>

</style>
